__turbopack_context__.v({
  "icon": "PasswordTextField-module-scss-module__y4RSnG__icon",
});
